<script>
import feedActivityTable from './feed-activity.table.js'
import getExportedFilename from '../../utils/get-exported-filename'
import FeedActivityContent from './components/feed-activity-content'

export default {
  name: 'FeedActivity',
  page: {
    title: 'Feed Activity',
  },
  components: {
    FeedActivityContent,
  },
  data() {
    return {
      table: feedActivityTable(this),
    }
  },
  methods: {
    getExportedFilename() {
      return getExportedFilename(this.table.tableName)
    },
  },
}
</script>

<template>
  <main-layout title="Feed Activity">
    <table-layout
      hider
      :table-name="table.tableName"
      :processor="table.processor"
      :filters="table.filters"
      :columns="table.columns"
      :fragments="false"
      :quantity="[25, 50, 100, 200]"
      :export-filename="getExportedFilename"
    >
      <template
        slot="expandedRow"
        slot-scope="{ row, columns }"
      >
        <feed-activity-content
          :row="row"
          :columns="columns"
        />
      </template>
    </table-layout>
  </main-layout>
</template>
